import type {AttachmentClassificationResponse} from 'src/api/ProactApiClient';
import type {IFormDataV2, IFormFieldV2} from 'src/types/FormV2';

export const AttachmentClassificationDocumentTitle =
  'Attachment Classifications';

export const MapAttachmentClassificationResponseToFormData = (
  resp: AttachmentClassificationResponse
): IFormDataV2 => {
  return {
    id: resp.id,
    name: resp.name ?? '',
    description: resp.description ?? '',
  };
};

export const GetDefaultAttachmentClassificationFormData = (): IFormDataV2 => {
  return {
    name: '',
    description: '',
  };
};

export const ATTACHMENT_CLASSIFICATION_FORM_META: IFormFieldV2[] = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    size: 'md',
    validation: {maxLength: 255},
  },
  {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    validation: {maxLength: 1000},
    textboxOptions: {multiline: true},
  },
];
